import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "backdrop"];

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    this.backdropTarget.classList.toggle("hidden");

    const isOpen = !this.menuTarget.classList.contains("hidden");
    if (isOpen) {
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }
}
